// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_HealthCheckResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/healthCheck
 *
 * Emits a primitive bool inside the envelope's `dados` field — true when
 * the upstream Go franchises-service health probe succeeds.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Franquias_HealthCheckResponseDados = boolean;

export type Franquias_HealthCheckResponse = ApiResponse<Franquias_HealthCheckResponseDados>;

registerResponseContract('Franquias_HealthCheckResponse', {})
